document.addEventListener("DOMContentLoaded", function () {

    window.newsletterConfig = window.newsletterConfig || {
        apiUrl: '',
        apiKey: ''
    };

    const validate = function (formData) {
        // Validate fields: first / last name, date of birth, zip
        const email = (formData.get('email') || '').trim();
        const firstname = (formData.get('firstname') || '').trim();
        const lastname = (formData.get('lastname') || '').trim();
        const day = formData.get('day');
        const month = formData.get('month');
        const year = formData.get('year');
        const zip = (formData.get('zip') || '').trim();

        // const date = moment().date(day).month(month).year(year);
        const date = moment(year.padStart(4, '0') + '-' + month.padStart(2, '0') + day.padStart(2, '0'), 'YYYY-MM-DD');

        const validation = {
            email: !!email,
            firstname: !!firstname,
            lastname: !!lastname,
            date: date.isValid() && moment().diff(date, 'years') > 18,
            zip: !!zip && /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip),
        };

        return {
            isValid: Object.values(validation).reduce(function (accumulator, value) {
                return accumulator && value;
            }, true),
            email,
            firstname,
            lastname,
            day,
            month,
            year,
            date,
            zip,
            validation
        };
    };

    const resetForm = function (form) {
        form.classList.remove('newsletter-form-wrapper--error');

        form.querySelectorAll('input').forEach((input) => {
            input.classList.remove('invalid');
            input.removeAttribute('aria-invalid');
        })
    };

    const showFailedValidation = function (form, validated) {
        form.classList.add('newsletter-form-wrapper--error');

        for (let key in validated.validation || {}) {
            if (validated.hasOwnProperty(key)) {
                const keys = 'date' === key ? ['day', 'month', 'year'] : [key];
                keys.forEach((subKey) => {
                    const input = form.querySelector('input[name="' + subKey + '"]');
                    const value = validated.validation['date' === key ? key : subKey];
                    if (input) {
                        if (value) {
                            input.classList.remove('invalid');
                            input.removeAttribute('aria-invalid');
                        } else {
                            input.classList.add('invalid');
                            input.setAttribute('aria-invalid', true);
                        }
                    }
                })
            }
        }
    }

    const getPayload = function (settings) {
        const data = {
            "entryType": "consumer",
            "service": "jameson-us",
            "brand": "Jameson",
            "contactType": "B2C",
            "email": settings.email,
            "firstName": settings.firstname,
            "lastName": settings.lastname,
            "postcode": settings.zip,
            "countryCode": "US",
            "languageCode": "en",
            "dateOfBirth": settings.dateOfBirth,
            "newsletter": (settings.newsletter) ? 1 : 0,
            "optIns": [
                {
                    "brandId": "Jameson",
                    "optInStatus": (settings.newsletter) ? 1 : 0,
                    "legalConsent": "By clicking sign up you agree to receive news and invites from Jameson and other trusted brands from Pernod Ricard USA."
                },
                {
                    "brandId": "Jameson",
                    "optInStatus": (settings.newsletter) ? 1 : 0,
                    "createdDate": new Date().toISOString(),
                    "legalConsent": "Get firsthand updates on our new products, events, recipes and more. By ticking this box, you agree to receive news and invites from Jameson and other trusted brands* from Pernod Ricard USA."
                }
            ],
            "prEntity": "PR USA",
            "touchPointName": "Jameson_ECommerce_API",
            "touchPointType": "E-Commerce",
            "activityId": "BrandWebsite_E-commerce_Jameson",
            "activityName": "BrandWebsite_E-commerce_Jameson",
            "activityType": "Newsletter",
        };

        return {
            id: window.uuid.v4(),
            data,
            signature: window.CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(JSON.stringify(data), newsletterConfig.apiKey))
        }
    }

    const newsletterHandler = function (form) {
        const email = form.querySelector('.field--primary input');
        if (email) {
            email.addEventListener('input', (event) => {
                const canShow = email.value.indexOf('@') !== -1;
                if (canShow) {
                    form.classList.add('newsletter-form-wrapper--visible');
                } else {
                    form.classList.remove('newsletter-form-wrapper--visible');
                }
            });
        }

        form.addEventListener('submit', function (event) {
            event.preventDefault();

            resetForm(form);

            const formData = new FormData(form);
            const validated = validate(formData);
            if (!validated.isValid) {
                showFailedValidation(form, validated);

                return false;
            }

            if (window.googleTagManagerService) {
                googleTagManagerService.newsletter('signup-submit');
            }

            // Prepare CDB payload
            const payload = getPayload({
                email: validated.email,
                firstname: validated.firstname,
                lastname: validated.lastname,
                zip: validated.zip,
                dateOfBirth: validated.date.format('YYYY-MM-DD'),
                newsletter: 1
            });

            // Post to B2B Keeper endpoint
            const config = {
                method: 'post',
                url: window.newsletterConfig.apiUrl + "api/keeper",
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: false,
                data: JSON.stringify(payload)
            };

            window.axios(config)
                .then((response) => {
                    form.classList.add('newsletter-form-wrapper--success');
                })
                .catch((error) => {
                    console.error('Newsletter failed', error)
                    form.classList.add('newsletter-form-wrapper--error');
                });

            return false;
        });
    };

    ['#form__popup_newsletter', '#ContactFooter'].forEach(function (id) {
        const form = document.querySelector(id);
        if (form) {
            newsletterHandler(form);
        }
    });

});